<template>
    <!--  -->
    <el-container v-loading="isShow" element-loading-text="拼命加载中">
        <div class="comp">
            <div class="panelBox">
                <div class="panel" v-if="datas[tabmonth]">
                    <div style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 50px;">
                        <div class="tit">当月数据</div>

                        <div class="cell">
                            <div :class="{ active2: tabmonth == index }" v-for="(item, index) in datas" :key="index"
                                @click="thisClick(index, item)">{{ item.shopName }}</div>
                        </div>
                    </div>
                    <div class="nucleuscon">
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">总收入</div>
                                <div class="data">
                                    <div class="cell1">{{ datas[tabmonth].monthPerformance.saleMoney.toFixed(2) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">总购宠数</div>
                                <div class="data">
                                    <div class="cell1">{{ datas[tabmonth].monthPerformance.salePetCount }}
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">活体销售金额</div>
                                <div class="data">
                                    <div class="cell1">{{ datas[tabmonth].monthPerformance.salePetMoney.toFixed(2) }}
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">商品销售金额</div>
                                <div class="data">
                                    <div class="cell1">{{ datas[tabmonth].monthPerformance.saleGoodsMoney.toFixed(2) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">医疗销售金额</div>
                                <div class="data">
                                    <div class="cell1">{{ datas[tabmonth].monthPerformance.saleMedicalMoney.toFixed(2) }}
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">洗美销售金额</div>
                                <div class="data">
                                    <div class="cell1">{{ datas[tabmonth].monthPerformance.saleWashMoney.toFixed(2) }}
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">会员卡销售金额</div>
                                <div class="data">
                                    <div class="cell1">{{ datas[tabmonth].monthPerformance.vipCardMoney.toFixed(2) }}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel2">
                    <div class="tit">当月数据饼状图</div>
                    <div class="tableBox" id="myChart0" style="height: 220px;"></div>
                </div>
            </div>
            <div class="panelBox" v-if="Daydatas">
                <div class="panel">
                    <div style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 50px;">
                        <div class="tit">当日数据</div>
                        <el-date-picker style="width: 130px; margin-left: 10px" size="mini" v-model="currDay" type="date"
                            value-format="timestamp" :picker-options="{}" placeholder="选择日期" @change="changePicker"
                            :clearable="false">
                        </el-date-picker>
                    </div>
                    <div class="nucleuscon">
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">总收入</div>
                                <div class="data">

                                    <div class="cell1">{{ Daydatas.saleMoney.toFixed(2) }} </div>
                                </div>
                            </div>
                        </div>
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">总购宠数</div>
                                <div class="data">
                                    <div class="cell1">{{ Daydatas.salePetCount }} </div>
                                </div>
                            </div>
                        </div>
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">活体销售金额</div>
                                <div class="data">
                                    <div class="cell1">{{ Daydatas.salePetMoney.toFixed(2) }} </div>
                                </div>
                            </div>
                        </div>
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">商品销售金额</div>
                                <div class="data">
                                    <div class="cell1">{{ Daydatas.saleGoodsMoney.toFixed(2) }} </div>
                                </div>
                            </div>
                        </div>
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">医疗销售金额</div>
                                <div class="data">
                                    <div class="cell1">{{ Daydatas.saleMedicalMoney.toFixed(2) }} </div>
                                </div>
                            </div>
                        </div>
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">洗美销售金额</div>
                                <div class="data">
                                    <div class="cell1">{{ Daydatas.saleWashMoney.toFixed(2) }} </div>
                                </div>
                            </div>
                        </div>
                        <div class="nucleusitem">
                            <div class="content">
                                <div class="currentit">会员卡销售金额</div>
                                <div class="data">
                                    <div class="cell1">{{ Daydatas.vipCardMoney.toFixed(2) }} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel2">
                    <div class="tit">当日数据饼状图</div>
                    <div class="tableBox" id="myChart1" style="height: 220px;"></div>
                </div>
            </div>
            <!-- 月目标完成度 -->
            <div class="panelBox" v-if="datas">
                <div class="panel1">
                    <div class="tit">
                        <div>门店月目标进度</div>
                        <div class="cell" style="display: flex;">
                            <div :class="{ active: tab == index }" v-for="(item, index) in weekOptions" :key="index"
                                @click="weekClick(item.value)">{{ index == 0 ? '全部' : `第${index}周` }}</div>

                            <!-- <div :class="{ active: tab == index }" v-for="(item, index) in datas" :key="index"
                                @click="weekClick(index)"> {{ index == 0 ? '全部' : `第${index}周` }}</div> -->
                        </div>
                    </div>
                    <div class="tableBox">
                        <div class="tit1">
                            <div class="cell1">项目</div>
                            <div class="cell1" v-for="(item, indexs) in datas" :key="indexs">
                                {{ item.shopName }}
                            </div>
                        </div>
                        <div class="row1">
                            <div class="cell1">活体销售目标</div>
                            <div class="cell1" v-for="(itam, index) in datas" :key="index">
                                <span v-if="tab == 0"> {{ itam.monthPerformance.salePetCount }}/{{
                                    itam.shopMonthTarget.salePetCount }}只</span>
                                <span v-else> {{ itam.weekPerformance[tab - 1].salePetCount }}/{{
                                    itam.weekMonthTarget[tab - 1].salePetCount }}只</span>
                            </div>
                        </div>
                        <div class="row1">
                            <div class="cell1">活体销售金额</div>
                            <div class="cell1" v-for="(itam, index) in datas" :key="index">
                                <span v-if="tab == 0"> {{ (itam.monthPerformance.salePetMoney).toFixed(2) }}/{{
                                    itam.shopMonthTarget.salePetMoney }}</span>
                                <span v-else>{{ (itam.weekPerformance[tab - 1].salePetMoney).toFixed(2) }}/ {{
                                    itam.weekMonthTarget[tab - 1].salePetMoney }}</span>
                            </div>
                        </div>
                        <div class="row1">
                            <div class="cell1">商品销售金额</div>
                            <div class="cell1" v-for="(itam, index1) in datas" :key="index1">
                                <span v-if="tab == 0"> {{ (itam.monthPerformance.saleGoodsMoney).toFixed(2) }}/{{
                                    itam.shopMonthTarget.saleGoodsMoney }}</span>
                                <span v-else>{{ (itam.weekPerformance[tab - 1].saleGoodsMoney).toFixed(2) }}/ {{
                                    itam.weekMonthTarget[tab - 1].saleGoodsMoney }}</span>
                            </div>
                        </div>
                        <div class="row1">
                            <div class="cell1">医疗销售金额</div>
                            <div class="cell1" v-for="(itam, index1) in datas" :key="index1">
                                <span v-if="tab == 0 && itam.shopMonthTarget.saleMedicalMoney != 0"> {{
                                    (itam.monthPerformance.saleMedicalMoney).toFixed(2) }}/{{
        itam.shopMonthTarget.saleMedicalMoney }}</span>
                                <span v-if="tab == 0 && itam.shopMonthTarget.saleMedicalMoney == 0"> {{
                                    itam.monthPerformance.saleMedicalMoney.toFixed(2) }}/0</span>
                                <span v-if="tab !== 0 && itam.shopMonthTarget.saleMedicalMoney != 0">{{
                                    (itam.weekPerformance[tab - 1].saleMedicalMoney).toFixed(2) }}/ {{
            itam.weekMonthTarget[tab - 1].saleMedicalMoney }}</span>
                                <span v-else-if="tab !== 0 && itam.shopMonthTarget.saleMedicalMoney == 0">{{
                                    (itam.weekPerformance[tab - 1].saleMedicalMoney).toFixed(2) }}/0</span>
                            </div>
                        </div>
                        <div class="row1">
                            <div class="cell1">洗美销售金额</div>
                            <div class="cell1" v-for="(itam, index1) in datas" :key="index1">
                                <span v-if="tab == 0"> {{ (itam.monthPerformance.saleWashMoney).toFixed(2) }}/{{
                                    itam.shopMonthTarget.saleWashMoney }}</span>
                                <span v-else> {{ (itam.weekPerformance[tab - 1].saleWashMoney).toFixed(2) }}/{{
                                    itam.weekMonthTarget[tab - 1].saleWashMoney }}</span>
                            </div>
                        </div>
                        <div class="row1">
                            <div class="cell1">销售总额金额</div>
                            <div class="cell1" v-for="(itam, index1) in datas" :key="index1">
                                <span v-if="tab == 0"> {{ (itam.monthPerformance.saleMoney).toFixed(2) }}/{{
                                    itam.shopMonthTarget.saleMoney
                                }}</span>
                                <span v-else> {{ (itam.weekPerformance[tab - 1].saleMoney).toFixed(2) }}/{{itam.weekMonthTarget[tab - 1].saleMoney }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel2">
                    <div class="tit">门店月目标进度</div>
                    <div class="tableBox" id="myChart3" style="width: 100%;height: 420px"></div>
                </div>
            </div>
            <!-- 周目标完成度 -->
            <div class="panelBox" v-if="datas">
                <div class="panel1">
                    <div class="tit">
                        <div>门店周目标进度</div>
                        <div class="cell" style="display: flex;">
                            <div :class="{ active1: tabshop == index1 }" v-for="(item, index1) in datas" :key="index1"
                                @click="shopClick(index1)"> {{ item.shopName }}</div>
                        </div>
                    </div>
                    <!-- v-if="!$public.isNull(datas.shop_week_data_list)" -->
                    <div class="tableBox">
                        <div class="tit1">
                            <div class="cell1">项目</div>
                            <div class="cell1 row">
                                活体销售目标
                            </div>
                            <div class="cell1 row">
                                活体销售金额
                            </div>
                            <div class="cell1 row">
                                商品销售金额
                            </div>
                            <div class="cell1 row">
                                医疗销售金额
                            </div>
                            <div class="cell1 row">
                                洗美销售金额
                            </div>
                            <div class="cell1 row">
                                总销售金额
                            </div>
                        </div>
                        <div class="row1 row">

                            <div class="cell1">
                                <div v-for="(shop, shopIndex) in datas[tabshop].weekMonthTarget.length" :key="shopIndex">
                                    <div style="border-bottom: 1px solid #e6e6e6">第{{ shop }}周目标</div>
                                    <div style="border-bottom: 1px solid #e6e6e6">第{{ shop }}周完成度</div>
                                </div>
                                <div style="border-bottom: 1px solid #e6e6e6">月度总目标</div>
                                <div style="border-bottom: 1px solid #e6e6e6">月度完成度</div>
                            </div>
                            <div class="cell1">
                                <div v-for="(shop, shopIndex) in datas[tabshop].weekMonthTarget" :key="shopIndex">
                                    <div style="border-bottom: 1px solid #e6e6e6"> {{
                                        datas[tabshop].weekPerformance[shopIndex].salePetCount }}/{{ shop.salePetCount }}
                                    </div>
                                    <div style="border-bottom: 1px solid #e6e6e6"> {{
                                        (datas[tabshop].weekPerformance[shopIndex].salePetCount / shop.salePetCount *
                                            100).toFixed(2)
                                    }}%</div>
                                </div>
                                <div>
                                    <div style="border-bottom: 1px solid #e6e6e6">{{
                                        datas[tabshop].monthPerformance.salePetCount }}/ {{
        datas[tabshop].shopMonthTarget.salePetCount }}</div>
                                    <div style="border-bottom: 1px solid #e6e6e6">{{
                                        (datas[tabshop].monthPerformance.salePetCount /
                                            datas[tabshop].shopMonthTarget.salePetCount * 100).toFixed(2) }}%
                                    </div>
                                </div>
                            </div>
                            <div class="cell1">
                                <div v-for="(shop, shopIndex) in datas[tabshop].weekMonthTarget" :key="shopIndex">
                                    <div style="border-bottom: 1px solid #e6e6e6"> {{
                                        datas[tabshop].weekPerformance[shopIndex].salePetMoney.toFixed(2) }}/{{
        shop.salePetMoney }}
                                    </div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-if="shop.salePetMoney!==0"> {{
                                        (datas[tabshop].weekPerformance[shopIndex].salePetMoney.toFixed(2) /
                                            shop.salePetMoney *
                                            100).toFixed(2)
                                    }}%</div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-else>0 </div>
                                    
                                </div>
                                <div>
                                    <div style="border-bottom: 1px solid #e6e6e6">{{
                                        datas[tabshop].monthPerformance.salePetMoney.toFixed(2) }}/ {{
        datas[tabshop].shopMonthTarget.salePetMoney }}</div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-if="datas[tabshop].shopMonthTarget.salePetMoney!==0">{{
                                        (datas[tabshop].monthPerformance.salePetMoney.toFixed(2) /
                                            datas[tabshop].shopMonthTarget.salePetMoney * 100).toFixed(2) }}%
                                    </div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-else>0
                                    </div>
                                </div>
                            </div>
                            <div class="cell1">
                                <div v-for="(shop, shopIndex) in datas[tabshop].weekMonthTarget" :key="shopIndex">
                                    <div style="border-bottom: 1px solid #e6e6e6"> {{
                                        datas[tabshop].weekPerformance[shopIndex].saleGoodsMoney.toFixed(2) }}/{{
        shop.saleGoodsMoney
    }}</div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-if="shop.saleGoodsMoney!==0"> {{
                                        (datas[tabshop].weekPerformance[shopIndex].saleGoodsMoney.toFixed(2) /
                                            shop.saleGoodsMoney *
                                            100).toFixed(2)
                                    }}%</div>
                                     <div style="border-bottom: 1px solid #e6e6e6" v-else>0</div>
                                </div>
                                <div>
                                    <div style="border-bottom: 1px solid #e6e6e6">{{
                                        datas[tabshop].monthPerformance.saleGoodsMoney.toFixed(2) }}/ {{
        datas[tabshop].shopMonthTarget.saleGoodsMoney }}</div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-if="datas[tabshop].shopMonthTarget.saleGoodsMoney!==0">{{
                                        (datas[tabshop].monthPerformance.saleGoodsMoney.toFixed(2) /
                                            datas[tabshop].shopMonthTarget.saleGoodsMoney * 100).toFixed(2) }}%
                                    </div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-else>0</div>
                                </div>
                            </div>
                            <div class="cell1">
                                <div v-for="(shop, shopIndex) in datas[tabshop].weekMonthTarget" :key="shopIndex">
                                    <div v-if="shop.saleMedicalMoney != 0" style="border-bottom: 1px solid #e6e6e6">{{
                                        datas[tabshop].weekPerformance[shopIndex].saleMedicalMoney.toFixed(2) }}/{{
        shop.saleMedicalMoney }}</div>
                                    <div v-if="shop.saleMedicalMoney == 0" style="border-bottom: 1px solid #e6e6e6">{{datas[tabshop].weekPerformance[shopIndex].saleMedicalMoney.toFixed(2) }}/0</div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-if="shop.saleMedicalMoney != 0"> {{
                                        (datas[tabshop].weekPerformance[shopIndex].saleMedicalMoney.toFixed(2) /
                                            shop.saleMedicalMoney
                                            *
                                            100).toFixed(2)
                                    }}%</div>
                                    <div v-else style="border-bottom: 1px solid #e6e6e6">0</div>
                                </div>
                                <div v-if="datas[tabshop].shopMonthTarget.saleMedicalMoney">
                                    <div style="border-bottom: 1px solid #e6e6e6">{{
                                        datas[tabshop].monthPerformance.saleMedicalMoney.toFixed(2) }}/ {{
        datas[tabshop].shopMonthTarget.saleMedicalMoney }}</div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-if="datas[tabshop].shopMonthTarget.saleMedicalMoney!==0">{{
                                        (datas[tabshop].monthPerformance.saleMedicalMoney.toFixed(2) /
                                            datas[tabshop].shopMonthTarget.saleMedicalMoney * 100).toFixed(2) }}%
                                    </div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-else>0
                                    </div>
                                </div>
                                <div v-else>
                                    <div style="border-bottom: 1px solid #e6e6e6">0</div>
                                    <div style="border-bottom: 1px solid #e6e6e6">0</div>
                                </div>
                            </div>
                            <div class="cell1">
                                <div v-for="(shop, shopIndex) in datas[tabshop].weekMonthTarget" :key="shopIndex">
                                    <div style="border-bottom: 1px solid #e6e6e6"> {{
                                        datas[tabshop].weekPerformance[shopIndex].saleWashMoney.toFixed(2) }}/{{
        shop.saleWashMoney }}
                                    </div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-if="shop.saleWashMoney!==0"> {{
                                        (datas[tabshop].weekPerformance[shopIndex].saleWashMoney.toFixed(2) /
                                            shop.saleWashMoney *
                                            100).toFixed(2)
                                    }}%</div>
                                     <div style="border-bottom: 1px solid #e6e6e6" v-else> 0</div>
                                </div>
                                <div>
                                    <div style="border-bottom: 1px solid #e6e6e6">{{
                                        datas[tabshop].monthPerformance.saleWashMoney.toFixed(2) }}/ {{
        datas[tabshop].shopMonthTarget.saleWashMoney }}</div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-if="datas[tabshop].shopMonthTarget.saleWashMoney!==0">{{
                                        (datas[tabshop].monthPerformance.saleWashMoney.toFixed(2) /
                                            datas[tabshop].shopMonthTarget.saleWashMoney * 100).toFixed(2) }}%
                                    </div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-else>0
                                    </div>
                                </div>
                            </div>
                            <div class="cell1">
                                <div v-for="(shop, shopIndex) in datas[tabshop].weekMonthTarget" :key="shopIndex">
                                    <div style="border-bottom: 1px solid #e6e6e6"> {{
                                        datas[tabshop].weekPerformance[shopIndex].saleMoney.toFixed(2) }}/{{ shop.saleMoney
    }}</div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-if="shop.saleMoney!==0">{{
                                        (datas[tabshop].weekPerformance[shopIndex].saleMoney.toFixed(2) / shop.saleMoney *
                                            100).toFixed(2)
                                    }}%</div>
                                     <div style="border-bottom: 1px solid #e6e6e6" v-else>0</div>
                                </div>
                                <div>
                                    <div style="border-bottom: 1px solid #e6e6e6">{{
                                        datas[tabshop].monthPerformance.saleMoney.toFixed(2) }}/ {{
        datas[tabshop].shopMonthTarget.saleMoney }}</div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-if="datas[tabshop].shopMonthTarget.saleMoney!==0">{{
                                        (datas[tabshop].monthPerformance.saleMoney.toFixed(2) /
                                            datas[tabshop].shopMonthTarget.saleMoney * 100).toFixed(2) }}%
                                    </div>
                                    <div style="border-bottom: 1px solid #e6e6e6" v-else>0
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row1 row">


                        </div>
                    </div>
                </div>
                <div class="panel2">
                    <div class="tit">门店周目标进度</div>
                    <div class="tableBox" id="myChart4" style="height: 420px;margin-top: 40px;"></div>
                </div>
            </div>
            <!-- 部门 -->
            <div class="panelBox" v-if="datas">
                <div class="panel1">
                    <div class="tit">
                        <div>部门业绩PK</div>
                        <div class="cell" style="display: flex;">
                            <div :class="{ active: tabpk == index }" v-for="(item, index) in datas.length" :key="index"
                                @click="MentClick(index)">第 {{ index + 1 }}周</div>
                        </div>
                    </div>
                    <div class="tableBox" style="margin-top: 40px;">
                        <div class="tit1">
                            <div class="cell1">部门</div>
                            <div class="cell1">项目</div>
                            <div class="cell1 row" v-for="(item, index) in datas.slice(1, 5)" :key="index">
                                <span v-show="item.shopId"> {{ item.shopName }}</span>
                            </div>
                        </div>
                        <div class="row1 row">
                            <div class="cell1" style="display: flex;flex-direction: column;justify-content: center;">
                                销售部
                            </div>

                            <div class="cell1">
                                <div style="border-bottom: 1px solid #e6e6e6">活体销售只数</div>
                            </div>
                            <div class="cell1" v-for="(shop, shopIndex) in datas.slice(1, 5)" :key="shopIndex">
                                <div style="border-bottom: 1px solid #e6e6e6"> {{ shop.sale[tabpk] }}</div>
                            </div>
                        </div>
                        <div class="row1 row">
                            <div class="cell1" style="display: flex;flex-direction: column;justify-content: center;">
                                医疗部
                            </div>
                            <div class="cell1">
                                <div style="border-bottom: 1px solid #e6e6e6">医疗服务订单数</div>
                            </div>
                            <div class="cell1" v-for="(shop, shopIndex) in datas.slice(1, 5)" :key="shopIndex">
                                <div style="border-bottom: 1px solid #e6e6e6"> {{ shop.medical[tabpk] }}</div>
                            </div>
                        </div>
                        <div class="row1 row">
                            <div class="cell1" style="display: flex;flex-direction: column;justify-content: center;">
                                洗美部
                            </div>
                            <div class="cell1">
                                <div style="border-bottom: 1px solid #e6e6e6">洗美服务订单数</div>
                            </div>
                            <div class="cell1" v-for="(shop, shopIndex) in datas.slice(1, 5)" :key="shopIndex">
                                <div style="border-bottom: 1px solid #e6e6e6"> {{ shop.wash[tabpk] }}</div>
                            </div>
                        </div>
                        <div class="row1 row">
                            <div class="cell1" style="display: flex;flex-direction: column;justify-content: center;">
                                团队
                            </div>
                            <div class="cell1">
                                <div style="border-bottom: 1px solid #e6e6e6">商品销售完成率</div>
                            </div>
                            <div class="cell1" v-for="(shop, shopIndex) in datas.slice(1, 5)" :key="shopIndex">
                                <div style="border-bottom: 1px solid #e6e6e6" v-if="shop.weekMonthTarget[tabpk].saleGoodsMoney!==0"> {{ ((shop.weekPerformance[tabpk].saleGoodsMoney/shop.weekMonthTarget[tabpk].saleGoodsMoney)*100.0).toFixed(2)}}%</div>
                                <div style="border-bottom: 1px solid #e6e6e6" v-else> 0</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel2">
                    <div class="tit">部门业绩PK图</div>
                    <div class="tableBox" id="myChart6" style="height: 420px"></div>
                </div>
            </div>

        </div>
    </el-container>
</template>
<script>
import echarts from "echarts";
export default {
    data() {
        return {
            isShow: false,
            datas: {
                shopMonthTarget: [],
                weekMonthTarget: [],
            },
            Daydatas: {},
            myChart0: null,
            myChart1: null,
            myChart3: null,
            tab: 0,
            tabshop: 0,
            tabpk: 0,
            tabmonth: 0,
            active1: "active1",
            active2: "active2",
            active: "active",
            shopId: null,
            currDay: '', //日期
            shopOptions: [{ //门店筛选
                value: '',
                label: '全部'
            }, {
                value: '5e9412e0b2bfbc089daerr12',
                label: '金水区店'
            },{
                value: '5e9412e0b2bfbc089daerr18',
                label: '郑东新区店'
            }],
           weekOptions: [{ //门店筛选
                value: 0,
                label: '全部'
            }, {
                value: 1,
                label: '第一周'
            },  {
                value: 2,
                label: '第二周'
            }, {
                value: 3,
                label: '第三周'
            }, {
                value: 4,
                label: '第四周'
            }],

        };
    },
    computed: {},
    props: {
        refresh: {
            default: 0,
        },
    },
    watch: {
        refresh() {
            this.getDatas();
            this.getdays();
        },
    },
    created() {
        this.currDay = new Date();
        sessionStorage.setItem("pkDay", this.$public.FTimeStr10(this.currDay));
        this.getDatas();
        this.getdays();
    },
    mounted() {

    },
    methods: {
        // 当月门店目标
        thisClick: function (index, item) {
            this.tabmonth = index
            this.shopId = item.shopId
            this.getdays()
            this.draw0()
        },
        // 门店周目标进度
        shopClick(index1) {
            this.tabshop = index1
            this.draw4()
        },
        // 门店月目标进度
        weekClick: function (index) {
            this.tab = index
            this.draw3()
        },
        // 部门进度
        MentClick(index) {
            this.tabpk = index
            this.draw6()
        },

        changePicker(val) {
            console.log(val, 'val');
            sessionStorage.setItem("pkDay", this.$public.FTimeStr10(val));
            this.getdays()
            //   this.refresh++;
        },
        // 表格数据
        getDatas() {
            this.state1 = false;
            let params = {
                month: this.$public.FTime(
                    sessionStorage.getItem("pkMonth"),
                    "YYYY-MM"
                ), // 月份信息(2021-10)
            };
            // process.env.VUE_APP_zichan + http://test.huashengchongwu.com:8033/
            this.isShow = true;
            let loading = this.$loading()
            this.$http
                .get(process.env.VUE_APP_zichan + "/api/Performance/GetShopDataResponse",
                    params
                )
                .then((res) => {
                    loading.close();
                    this.isShow = false;
                    if (res.code == 0) {
                        this.datas = res.data.thisMonth.shopData;
                        this.$nextTick(() => {
                            this.state1 = true;
                            this.draw6();
                            this.draw0();
                            this.draw3();
                            this.draw4();
                            
                        });
                    }
                });
        },
        // 当日数据
        getdays() {
            this.state1 = false;
            let params = {
                month: this.$public.FTime(
                    sessionStorage.getItem("pkDay"),
                    "YYYY-MM-DD"
                ), // 月份信息(2021-10)
                shopId: this.shopId ? this.shopId : '',
            };
            this.isShow = true;
            let loading = this.$loading();
            this.$http
                .get(process.env.VUE_APP_zichan +"/api/Performance/GetShopDayDataResponse",
                    params
                )
                .then((res) => {
                    loading.close();
                    this.isShow = false;
                    if (res.code == 0) {
                        this.Daydatas = res.data;
                        this.$nextTick(() => {
                            this.state1 = true;
                            setTimeout(() => {
                                this.draw1();
                            }, 1000)

                            // this.draw1();
                        });
                    }

                });
        },
        draw0() {
            this.myChart0 = echarts.init(document.getElementById("myChart0"));
            let list = this.datas[this.tabmonth].monthPerformance;
            let listItem = [{ value: (list.salePetMoney).toFixed(2), name: '活体销售金额' }, { value: (list.saleWashMoney).toFixed(2), name: '洗美销售金额' }, { value: (list.saleMedicalMoney).toFixed(2), name: '医疗销售金额' }, { value: (list.saleGoodsMoney).toFixed(2), name: '商品销售金额' }];
            let arr = []
            for (let i = 0; i < listItem.length; i++) {
                arr.push(listItem[i])
            }
            this.myChart0.setOption({
                color: [
                    "#F5882A",
                    "#58A2F7",
                    "#FBCB63",
                    "#F76260",
                    "#8167F5",
                    "#F5EC67",
                    "#28D3DB",
                    "#96D9FF",
                ],
                legend: {
                    orient: 'horizontal',
                    x: 'top',
                    textStyle: {
                        fontSize: "16",
                        color: "#8C8C8C",
                        lineHeight: "10",
                    },
                    itemGap: 10,
                    data: arr,
                },
                series: [
                    {
                        type: "pie",
                        label: {
                            normal: {
                                position: 'outseide', // 在内部显示，outseide 是在外部显示
                                show: true,
                                formatter: '{c}',
                            }
                        },
                        top:50,
                        data: arr,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            })
        },
        draw1() {
            this.myChart1 = echarts.init(document.getElementById("myChart1"));
            let list = this.Daydatas;
            let listItem = [{ value: (list.salePetMoney).toFixed(2), name: '活体销售金额' }, { value: (list.saleWashMoney).toFixed(2), name: '洗美销售金额' }, { value: (list.saleMedicalMoney).toFixed(2), name: '医疗销售金额' }, { value: (list.saleGoodsMoney).toFixed(2), name: '商品销售金额' }];
            let arr = []
            for (let i = 0; i < listItem.length; i++) {
                arr.push(listItem[i])
            }
            this.myChart1.setOption({
                color: [
                    "#F5882A",
                    "#58A2F7",
                    "#FBCB63",
                    "#F76260",
                    "#8167F5",
                    "#F5EC67",
                    "#28D3DB",
                    "#96D9FF",
                ],
                legend: {
                    orient: 'horizontal',
                    x: 'top',
                    textStyle: {
                        fontSize: "16",
                        color: "#8C8C8C",
                        lineHeight: "10",
                    },
                    itemGap: 10,
                    data: arr,
                },
                series: [
                    {
                        type: "pie",
                        label: {
                            normal: {
                                position: 'outseide', // 在内部显示，outseide 是在外部显示
                                show: true,
                                formatter: '{c}',
                            }
                        },
                        top:50,
                        data: arr,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            })
        },
        getpiedata(per, tar) {
            let data = [];
            data.push(tar.salePetMoney == 0 ? 0 : (per.salePetMoney / tar.salePetMoney * 100.0).toFixed(2))
            data.push(tar.salePetCount == 0 ? 0 : (per.salePetCount / tar.salePetCount * 100.0).toFixed(2))
            data.push(tar.saleGoodsMoney == 0 ? 0 : (per.saleGoodsMoney / tar.saleGoodsMoney * 100.0).toFixed(2))
            data.push(tar.saleMedicalMoney == 0 ? 0 : (per.saleMedicalMoney / tar.saleMedicalMoney * 100.0).toFixed(2))
            data.push(tar.saleWashMoney == 0 ? 0 : (per.saleWashMoney / tar.saleWashMoney * 100.0).toFixed(2))
            return data;
        },
        draw3() {
            this.myChart3 = echarts.init(document.getElementById("myChart3"));
            let arr = ['活体销售金额', '活体销售只数', '商品销售金额', '医疗销售金额', '洗美销售金额']
            var echarData = [];
            let shop = []
            for (let i = 0; i < this.datas.length; i++) {
                let model = {};
                model.name = this.datas[i].shopName;
                model.type = 'bar';
                if (this.tab == 0) {
                    let per = this.datas[i].monthPerformance;
                    let tar = this.datas[i].shopMonthTarget;
                    model.data = this.getpiedata(per, tar);
                }
                else {
                    let per = this.datas[i].weekPerformance[this.tab - 1];
                    let tar = this.datas[i].weekMonthTarget[this.tab - 1];
                    model.data = this.getpiedata(per, tar);
                }
                shop.push(this.datas[i].shopName)
                echarData.push(model)
            }
            this.myChart3.setOption({
                tooltip: {// 提示框组件。// trigger:'item' 默认的鼠标移动到色块上触发
                    trigger: 'axis', // 鼠标只要在轴上就会触发
                    triggerOn: 'click', // 触发方式 一般不用 click 简化用户操作
                    //formatter:`{a}（系列名称），{b}（类目值），{c}（数值）`   点击时的回调 可以是模板字符串 也可以是函数
                    formatter: function (params) {
                        let arr1 = params[0].axisValue + '<br>'
                        for (let i = 0; i < params.length; i++) {
                            arr1 += params[i].seriesName + ' : ' + params[i].value + '<br>';
                        }
                        return arr1;
                    }
                },
                label: { // 柱状图 内部 显示数值
                    show: true,
                    rotate: 70,
                },
                legend: {//图例组件。图例组件展现了不同系列的标记(symbol)，颜色和名字。可以通过点击图例控制哪些系列不显示。
                    data: shop
                },
                grid: {
                    width: '80%' // 设置图表宽度为80%
                },
                xAxis: { // X Y 轴数据互换可以 变成横向柱状图
                    type: 'category',
                    data: arr,
                    axisLabel: {
                        interval: 0, // 显示所有标签
                        rotate: 30 // 旋转30度
                    }
                },
                yAxis: {

                },
                series: echarData
            })
        },
        draw4() {
      let newData = Object.assign({}, this.datas[this.tabshop]);
      this.myChart4 = echarts.init(document.getElementById("myChart4"));
      let arr = ["第一周", "第二周", "第三周", "第四周"];
      var echarData = [];
      let shop = [
        "活体销售只数",
        "活体销售金额",
        "商品销售金额",
        "医疗销售金额",
        "洗美销售金额",
      ];
      let shopKey =[
        "salePetCount",
        "salePetMoney",
        "saleGoodsMoney",
        "saleMedicalMoney",
        "saleWashMoney"
      ]
      console.log(this.datas, "测试");
      // 一共五个数组 第一个应该全是只数的数据  第二个应该全是销售金额的数据 第三个应该全是医疗销售金额的数据
      for (let i = 0; i < this.datas.length; i++) {
        let model = {};
        model.name = shop[i];
        model.type = "bar";
        let per = [];
        for (let index = 0; index < 4; index++) {
            per.push(((newData.weekPerformance[index][shopKey[i]]/newData.weekMonthTarget[index][shopKey[i]])* 100.0).toFixed(2))
        }
        model.data = per;
        echarData.push(model);
      }
        this.myChart4.setOption({
            tooltip: {// 提示框组件。// trigger:'item' 默认的鼠标移动到色块上触发
                trigger: 'axis', // 鼠标只要在轴上就会触发
                triggerOn: 'click', // 触发方式 一般不用 click 简化用户操作
                //formatter:`{a}（系列名称），{b}（类目值），{c}（数值）`   点击时的回调 可以是模板字符串 也可以是函数
                // formatter: function (params) {
                //     console.log(params, 'params');
                //     let arr1 = params[0].axisValue + '<br>'
                //     for (let i = 0; i < params.length; i++) {
                //         arr1 += params[i].seriesName + ' : ' + params[i].value + '<br>';
                //     }
                //     return arr1;
                // }
            },
            label: { // 柱状图 内部 显示数值
                show: true,
                rotate: 70,
            },
            legend: {//图例组件。图例组件展现了不同系列的标记(symbol)，颜色和名字。可以通过点击图例控制哪些系列不显示。
                data: shop
            },
            grid: {
                width: '80%' // 设置图表宽度为80%
            },
            xAxis: { // X Y 轴数据互换可以 变成横向柱状图
                type: 'category',
              data: arr,
                axisLabel: {
                    interval: 0, // 显示所有标签
                    rotate: 30 // 旋转30度
                }
            },
            yAxis: {
                type: 'value',
            },
            series: echarData
        })

    },
        draw6() {
            this.myChart6 = echarts.init(document.getElementById("myChart6"));
            let arr = ['销售', '医疗', '洗美']
            var echarData = [];
            let shop = []
            let datalist=this.datas.slice(1, 5)
            for (let i = 0; i < datalist.length; i++) {
                let model = {};
                model.name = datalist[i].shopName;
                model.type = 'bar';
                  let wash = datalist[i].wash[this.tabpk];
                   let medical = datalist[i].medical[this.tabpk];
                    let sale = datalist[i].sale[this.tabpk];
                    let dataslist=[]
                    dataslist.push(sale,medical,wash)
                    model.data = dataslist;
                shop.push(datalist[i].shopName)
                echarData.push(model)
            }
            this.myChart6.setOption({
                tooltip: {// 提示框组件。// trigger:'item' 默认的鼠标移动到色块上触发
                    trigger: 'axis', // 鼠标只要在轴上就会触发
                    triggerOn: 'click', // 触发方式 一般不用 click 简化用户操作
                    //formatter:`{a}（系列名称），{b}（类目值），{c}（数值）`   点击时的回调 可以是模板字符串 也可以是函数
                    // formatter: function (params) {
                    //     console.log(params, 'params');
                    //     let arr1 = params[0].axisValue + '<br>'
                    //     for (let i = 0; i < params.length; i++) {
                    //         arr1 += params[i].seriesName + ' : ' + params[i].value + '<br>';
                    //     }
                    //     return arr1;
                    // }
                },
                label: { // 柱状图 内部 显示数值
                    show: true,
                    rotate: 70,
                },
                legend: {//图例组件。图例组件展现了不同系列的标记(symbol)，颜色和名字。可以通过点击图例控制哪些系列不显示。
                    data: shop
                },
                grid: {
                    width: '80%' // 设置图表宽度为80%
                },
                xAxis: { // X Y 轴数据互换可以 变成横向柱状图
                    type: 'category',
                    data: arr,
                    axisLabel: {
                        interval: 0, // 显示所有标签
                        rotate: 30 // 旋转30度
                    }
                },
                yAxis: {

                },
                series: echarData
            })
        },
    },
};
</script>
<style scoped lang="scss">
.comp:nth-child(1)>.panelBox:nth-child(1)>.panel {
    border: 1px solid #dadcde;
    border-bottom: none;
}

.comp:nth-child(1)>.panelBox:nth-child(2)>.panel {
    border: 1px solid #d8d9da;
    // border-top: none;
}

.comp {
    // width: 100%;
    position: relative;
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    height: 100vh;
    // overflow: hidden;

    .cell {
        display: flex;
        border-radius: 10px;

        div {
            color: #8d8a8a;
            padding: 10px 10px;

        }

        .active {
            // background-color: $mainColor;
            color: #9d9b9b;
            border: 1px solid #a7a8aa;
            font-size: 14px;
            border-radius: 8px;
            cursor: pointer;
        }

        .active1 {
            // background-color: $mainColor;
            color: #9d9b9b;
            border: 1px solid #a7a8aa;
            font-size: 14px;
            border-radius: 8px;
            cursor: pointer;
        }

        .active2 {
            // background-color: $mainColor;
            color: #9d9b9b;
            border: 1px solid #a7a8aa;
            font-size: 14px;
            border-radius: 8px;
            cursor: pointer;
        }
    }

    .panelBox {
        display: flex;
        justify-content: space-around;
        width: 100%;

        .panel {
            padding: 22px 20px;
            box-sizing: border-box;
            width: 100%;
            width: calc(100% - 600px);
            // background-color: #fff;
            // border: 1px solid rgb(211, 209, 209);
            margin-right: 20px;
            line-height: 30px;
        }

        .panelitem {
            padding: 22px 20px;
            width: 580px;
            // border: 1px solid rgb(211, 209, 209);
        }


        .nucleuscon {
            margin-top: 10px;
            display: flex;

            .nucleusitem {
                border-right: 1px solid #ddd;
                width: 20%;
                display: flex;
                justify-content: center;
                // display: inline-block;
                box-sizing: border-box;
                margin: auto;
                margin-top: 20px;

                &:last-child {
                    border: none;
                }

                .content {
                    max-width: 180px;
                    margin: auto;
                }

                .currentit {
                    color: #666666;
                    font-size: 14px;
                }

                .data {
                    margin: 10px 0;
                    font-size: 20px;
                    font-weight: bold;
                    color: #333333;
                }

                .compare {
                    color: #666666;
                    font-size: 12px;
                }
            }
        }
    }

    .panel1 {
        padding: 22px 20px;
        box-sizing: border-box;
        width: calc(100% - 600px);
        min-width:900px;
        background-color: #fff;

        .tit {
            font-size: 18px;
            color: $fontColor;
            font-weight: bold;
            padding-bottom: 14px;
            display: flex;
            justify-content: space-between;
        }

        .tableBox {
            border-left: 1px solid #e6e6e6;

            .tit1 {
                display: flex;
                line-height: 52px;
                border-bottom: 1px solid #e6e6e6;

                .cell1 {
                    background-color: #f3f5fa;
                    width: 100%;
                    text-align: center;
                    border-right: 1px solid #e6e6e6;
                }
            }

            .row1 {
                display: flex;
                line-height: 52px;

                .cell1 {
                    width: 100%;
                    text-align: center;
                    border-right: 1px solid #e6e6e6;
                    border-bottom: 1px solid #e6e6e6;
                }
            }
        }
    }

    .panel2 {
        padding: 22px 20px;
        box-sizing: border-box;
        width: 600px;
        background-color: #fff;

        .tit {
            font-size: 18px;
            color: $fontColor;
            font-weight: bold;
            padding-bottom: 14px;
        }
    }



}

.row:nth-child(odd) {
    background: rgb(223, 218, 218);
}
</style>
  